import React from "react"
import { NavigationStep } from "../../models/NavigationStep"
import { useNavigation } from "../../context/NavigationContext"
import { translate } from "../../translations/translations"
import styles from "./Shared.module.css"

const stepSpecificSubtitles: Record<NavigationStep, string | null> = {
  [NavigationStep.AssetType]: translate("asset_type_subtitle"),
  [NavigationStep.Shipments]: translate("shipments_subtitle"),
  [NavigationStep.BusinessExpense]: translate("business_expense_subtitle"),
  [NavigationStep.BusinessImprovement]: translate(
    "business_improvement_subtitle",
  ),
  [NavigationStep.Results]: null,
}

const Header: React.FC = () => {
  const { currentStep } = useNavigation()

  return (
    <header className={styles.header}>
      <div className={styles.headerRow}>
        <div className={styles.leftCol}>
          <a
            className={styles.headerLogo}
            href="https://sensos.io/"
            aria-label="Main logo"
          >
            <img
              width="1000"
              height="380"
              src="https://sensos.io/wp-content/uploads/2024/06/Sensos-Logo-Negative.svg"
              className={styles.logoImg}
              alt="Sensos Logo"
              decoding="async"
            />
          </a>
        </div>
        <div className={styles.centerCol}>
          <h3>{translate("roi_calculator")}</h3>
        </div>
        <div className={styles.rightCol} />
      </div>
      <h1 className={styles.textCenter}>{translate("stop_guessing")}</h1>
      <h2 className={styles.textCenter}>
        {translate("supercharge_supply_chain")}
      </h2>
      {stepSpecificSubtitles[currentStep] && (
        <h3
          className={`${styles.textCenter} ${
            currentStep === NavigationStep.AssetType ? styles.hideOnMobile : ""
          }`}
        >
          {stepSpecificSubtitles[currentStep]}
        </h3>
      )}
    </header>
  )
}

export default Header
